// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_en-0";